import { useWeb3React } from '@web3-react/core';
import { Contract, ethers, Signer } from 'ethers';
import {
  ChangeEvent,
  MouseEvent,
  ReactElement,
  useEffect,
  useState,
  useRef
} from 'react';
//import { BigNumber } from 'ethers';
import { SignMessage } from './SignMessage';
import styled from 'styled-components';
import { Provider } from '../utils/provider';
import { SectionDivider } from './SectionDivider';
import { Row, Col, Form, Button} from 'react-bootstrap';
import { Link } from 'react-router-dom';

const StyledGreetingDiv = styled.div`
  display: grid;
  grid-template-rows: 1fr 1fr 1fr;
  grid-template-columns: 135px 2.7fr 1fr;
  grid-gap: 10px;
  place-self: center;
  align-items: center;
`;

const StyledLabel = styled.label`
  font-weight: bold;
`;

const StyledInput = styled.input`
  padding: 0.4rem 0.6rem;
  line-height: 2fr;
`;

const StyledButton = styled.button`
  width: 150px;
  height: 2rem;
  border-radius: 1rem;
  border-color: blue;
  cursor: pointer;
  place-self: center;
`;

const StyledAppDiv = styled.div`
  display: grid;
  grid-gap: 20px;
`;


export function HomePageApp(): ReactElement {
  return (
    <StyledAppDiv>
      <CreateHomePage />
    </StyledAppDiv>
  );
}

export function CreateHomePage(): ReactElement {
     
  return (
    <>
      
      <div className="container-fluid">
      <div className="row">
        <main role="main" className="col-lg-12 mx-auto" style={{ maxWidth: '1000px' }}>
          <div className="content mx-auto">
            <Row className="g-4">
              <div className="ratio ratio-16x9">
                <iframe src="https://www.youtube.com/embed/_ETEI6FXnWE?autoplay=1&rel=0&modestbranding=1" title="Cosmic Force intro video"  allowFullScreen></iframe>
              </div>
            </Row>
            <Row className="g-4">
            <h6 className="p-4 text-center">
            Cosmic Force is a Play To Earn space game being developed for the Vulcan Blockchain. As the path of evolution takes its form, transformations require great sacrifices, leaving behind everything. The Earth saga is now a faded memory in humanities history and survival. Humans are not the only interstellar lifeforms with the intention to endure the cosmos. In a finite universe resources and habitable planets have become a rarity. The current home planet needs now to colonize a further 6 identified planets to secure humanity’s future and defend against increasing alien attack. Cosmic Force Cadets are being recruited and trained to build the colony’s infrastructure, find resources, and also be the brave, fearless first line of planetary defense.
            </h6>
            </Row>
            <Row className="g-4">
            <img src='./images/Front_page_Cosmic_Force_logo_Spacefighter.jpg' className='img-fluid' alt='...' />
            </Row>
            <div>&nbsp;</div>
            <div>&nbsp;</div>
            <Row className="g-4">
              <Col className="social text-center">
              <a href="https://www.youtube.com/channel/UCq-Caghvu0KL91dKLKfL34w" target="_blank" rel="cosmic">
                <img  className="imgi" style={{ maxWidth: '100px' }} src="./images/yt_final.png" alt="Nature"></img>
              </a>
              </Col>
              <Col className="social text-center">
              <a href="https://discord.gg/jz5KvbEEuz" target="_blank" rel="cosmic">
                <img  className="imgi" style={{ maxWidth: '100px' }} src="./images/discord_final.png" alt="Nature"></img>
              </a>
              </Col>
              <Col className="social text-center">
              <a href="https://t.me/+PzYpcR_vE3RiY2M8" target="_blank" rel="cosmic">
                <img  className="imgi" style={{ maxWidth: '100px' }} src="./images/telegram_final.png" alt="Nature"></img>
              </a>
              </Col>
              <Col className="social text-center">
              <a href="https://medium.com/cosmic-force" target="_blank" rel="cosmic">
                <img  className="imgi" style={{ maxWidth: '100px' }} src="./images/medium_final.png" alt="Nature"></img>
              </a>
              </Col>
              <Col className="social text-center">
              <a href="https://twitter.com/WavemStudios" target="_blank" rel="cosmic">
                <img  className="imgi" style={{ maxWidth: '100px' }} src="./images/twitter_final.png" alt="Nature"></img>
              </a>
              </Col>
            </Row>
            <div>&nbsp;</div>
            <Row className="g-4">
              <div className="ratio ratio-16x9">
                <iframe src="https://www.youtube.com/embed/NwLPUL2jdDI?autoplay=1&rel=0&modestbranding=1" title="Cosmic Force intro video"  allowFullScreen></iframe>
              </div>
            </Row>
            <div>&nbsp;</div>
            <Row>
              <Col className="social text-center">
                <a href="https://landing.mailerlite.com/webforms/landing/n8q8y2" target="_blank" rel="cosmic">
                  Signup to keep updated on developments and releases of Cosmic Force 
                </a>
              </Col>
            </Row>
            <div>&nbsp;</div>
            <Row>
              <Col>
              <div className="ml-form-embed"
                data-account="1104702:o1r2r3b0u5"
                data-form="5872683:n8q8y2">
              </div>
            </Col>
            </Row>
            <div>
          </div>
          </div>
        </main>
      </div>
    </div>
    </>
  );
}
